import i18n from 'i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import { initReactI18next } from 'react-i18next'
import Backend from 'i18next-http-backend'
import appApi from 'api/appApi'
i18n
  .use(LanguageDetector)
  .use(Backend)
  .use(initReactI18next)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    // debug: true,
    fallbackLng: 'vi',
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['localStorage', 'navigator'],
      lookupLocalStorage: 'i18nextLng',
      caches: ['localStorage'],
    },
  })
  .then(async () => {
    try {
      const savedLng = localStorage.getItem('i18nextLng')
      // If user already has a language preference saved locally, use it
      if (savedLng) return

      // Otherwise, fetch from server for first-time or new-device login
      const uid = localStorage.getItem('id')
      if (!uid) throw new Error('new client')
      const user = await appApi.getUser(uid)
      if (user.lang) {
        i18n.changeLanguage(user.lang)
      }
    } catch (error) {
      // i18n.changeLanguage("vi");
    }
  })

export default i18n

